
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/weer-weerbericht",
      function () {
        return require("private-next-pages/[region]/[resort]/weer-weerbericht.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/weer-weerbericht"])
      });
    }
  